/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamItemPreviewViewModel } from "../types/ExamItemPreviewViewModel.ts";
import { examItemPreviewDetailViewModelSchema } from "./examItemPreviewDetailViewModelSchema.ts";
import { examTypeListValuePreviewViewModelSchema } from "./examTypeListValuePreviewViewModelSchema.ts";

export const examItemPreviewViewModelSchema = z.object({
  id: z.optional(
    z
      .number()
      .int()
      .describe("ID do vínculo da questão com a prova (ExamItemExam)."),
  ),
  examItemCompanyId: z
    .number()
    .int()
    .describe("ID do vínculo da questão com a empresa. Opcional.")
    .nullish(),
  pageBreak: z.optional(
    z
      .boolean()
      .describe(
        "Define se haverá quebra de página após esta questão na visualização prévia da prova.",
      ),
  ),
  examItem: z.optional(z.lazy(() => examItemPreviewDetailViewModelSchema)),
  examTypeList: z
    .array(z.lazy(() => examTypeListValuePreviewViewModelSchema))
    .describe(
      "Lista de alternativas da questão para visualização prévia (aplicável a SingleChoice e MultipleChoice). Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<ExamItemPreviewViewModel>;
